export const ORDER_TYPES = {
  ORDERS: "Orders",
  DATE: "Date",
}
